// for add employee

export const RESET_GET_USER_DETAILS = "reset_get_user_details";
export const GET_USER_DETAILS = "get_user_details";
export const GET_USER_DETAILS_SUCCESS = "get_user_details_success";
export const GET_USER_DETAILS_FAILURE = "get_user_details_failure";
